import {Button, Checkbox, Col, Input, message, Row, Select, Spin, Switch} from 'antd';
import TrailLinks from "component/utils/trail_links";
import {aclPermissions, hasPermissions} from "const/ACLPermissions";
import querystring from "query-string";
import {Component} from "react";
import cookie from 'react-cookies';
import {connect} from "react-redux";
import '../asset/style/add_case.css';
import {getUnauthorizedComponent} from '../component/dashboard/slidelist_utils';
import {post_response} from "../helper/request";
import {loadOrganisations} from '../redux_actions/users.action';
import {isSuperuser, isTrue, openEndPoint} from "../utils/utils";
import {antdSpinLoaderIcon, emailValidationPattern} from "../utils/const";
import {Divider} from "@mui/material";
import PasswordChecklist from "react-password-checklist"
import DownloadPassword from "../component/settings/manageusers/download.password";

const {Password} = Input;

class AddUserView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            username: '',
            email: '',
            firstName: '',
            lastName: '',
            password: '',
            confirmPassword: '',
            externalOrg: false,
            org: '',
            errorFlag: false,
            errorMessage: '',
            autoGeneratePassword: true,
            autoChangePassword: true,
            allowRetrievePassword: false,
        }

        this.is_superuser = isSuperuser()
    }

    componentDidMount() {
        this.generateComplexPassword()
        this.is_superuser && this.props.dispatch(loadOrganisations())
    }

    changeUsername = (event) => {
        this.setState({username: event.target.value.trim(), errorFlag: false, errorMessage: ''});
    }
    
    changeEmail = (event) => {
        this.setState({email: event.target.value, errorFlag: false, errorMessage: ''})
    }

    changeFirstName = (event) => {
        this.setState({firstName: event.target.value});
    }

    changeLastName = (event) => {
        this.setState({lastName: event.target.value});
    }

    changeExternalOrg = (checked) => {
        this.setState({externalOrg: checked, org: !checked ? '' : this.state.org,});
    }

    changePassword = (event) => {
        this.setState({
            password: event.target.value,
            errorFlag: false,
            errorMessage: '',
        });
    }

    changeConfirmPassword = (event) => {
        this.setState({
            confirmPassword: event.target.value,
            errorFlag: false,
            errorMessage: '',
        });
    }

    changeOrg = (value) => {
        this.setState({org: value});
    }

    filterOption = (input, option) => option.props.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0

    createUser = (e) => {
        const complexPasswordCheck = (cookie.load("organisation_setting") || {})["complex_password_check"];
        this.setState({isFetching: true});
        if (this.state.password.length < 8) {
            this.setState({
                errorFlag: true,
                errorMessage: 'Use 8 characters or more for your password.',
                password: '',
                confirmPassword: '',
                isFetching: false,
            });
            return;
        } else if (this.state.password !== this.state.confirmPassword) {
            this.setState({
                errorFlag: true,
                errorMessage: 'Passwords didn\'t match. Please try again.',
                password: '',
                confirmPassword: '',
                isFetching: false,
            });
            return;
        } else if (this.state.externalOrg && this.state.org === '') {
            this.setState({
                errorFlag: true,
                errorMessage: 'External Org is ON, but no external org provided.',
                isFetching: false,
            });
            if (!this.state.autoGeneratePassword) {
                this.setState({password: '', confirmPassword: '',})
            }
            return;
        } else {
            const emailValid = emailValidationPattern.test(this.state.email);
            if (!emailValid) {
                this.setState({
                    errorFlag: true,
                    errorMessage: 'Please enter a valid email address.',
                    email: '',
                    isFetching: false,
                });
                if (!this.state.autoGeneratePassword) {
                    this.setState({password: '', confirmPassword: '',})
                }
                return;
            }
        }
        const passwordRegex = /^(?:(?=.*[a-z])(?:(?=.*[A-Z])(?=.*[\d\W])|(?=.*\W)(?=.*\d))|(?=.*\W)(?=.*[A-Z])(?=.*\d)).{8,}$/;
        if (isTrue(complexPasswordCheck) && !passwordRegex.test(this.state.password)) {
            this.setState({
                errorFlag: true,
                errorMessage: 'Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character.',
                password: '',
                confirmPassword: '',
                isFetching: false,
            });
            return;
        }

        let val = {
            username: this.state.username,
            email: this.state.email,
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            password: this.state.password,
            autoChangePassword: this.state.autoChangePassword,
            organisation_id: this.is_superuser && this.state.externalOrg ? this.state.org : cookie.load('organisation_id')
        }

        let url = `/api/create_user/`;
        post_response(url, querystring.stringify(val))
            .then(response => {
                this.setState({isFetching: false});
                if (this.state.autoGeneratePassword) {
                    this.handleAutoGenerate();
                } else {
                    openEndPoint("/accesscontrol/", false, true);
                }
            })
            .catch(err => {
                const msg = err?.response?.data ? err.response.data : "Failed to Create User."
                this.handleCancel()
                this.setState({isFetching: false, errorFlag: true, errorMessage: msg});
                message.error("Failed to Create User.");
            });

    }

    handleAutoGenerate = () => {
        this.setState({
            isFetching: false,
            errorFlag: false,
            errorMessage: '',
            allowRetrievePassword: true,
        });
    }

    generateComplexPassword = () => {
        const length = 12;
        const lowercaseCharset = "abcdefghijklmnopqrstuvwxyz";
        const uppercaseCharset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const digitCharset = "0123456789";
        const specialCharset = "!@#$%^&*()_+";

        const password =
            lowercaseCharset.charAt(Math.floor(Math.random() * lowercaseCharset.length)) +
            uppercaseCharset.charAt(Math.floor(Math.random() * uppercaseCharset.length)) +
            digitCharset.charAt(Math.floor(Math.random() * digitCharset.length)) +
            specialCharset.charAt(Math.floor(Math.random() * specialCharset.length)) +
            Array.from({length: length - 4}, () => {
                const charset = lowercaseCharset + uppercaseCharset + digitCharset + specialCharset;
                return charset.charAt(Math.floor(Math.random() * charset.length))
            }).join('');
        this.setState({password: password, confirmPassword: password, autoGeneratePassword: true});
    }

    handleAutoGenerateChange = (e) => {
        if (e.target.checked) {
            this.generateComplexPassword();
        } else {
            this.setState({password: '', confirmPassword: '', autoGeneratePassword: false});
        }
    };

    handleCancel = () => {
        this.setState({
            allowRetrievePassword: false,
            username: '',
            isFetching: false,
            errorFlag: false,
            errorMessage: '',
            firstName: '',
            lastName: '',
            email: ''
        });
        if (!this.state.autoGeneratePassword) {
            this.setState({password: '', confirmPassword: '',})
        }
    }

    handleOk = () => {
        this.handleCancel()
        openEndPoint("/accesscontrol/", false, true);
    }

    render() {
        const complexPasswordCheck = (cookie.load("organisation_setting") || {})["complex_password_check"];
        const passwordRegex = /^(?:(?=.*[a-z])(?:(?=.*[A-Z])(?=.*[\d\W])|(?=.*\W)(?=.*\d))|(?=.*\W)(?=.*[A-Z])(?=.*\d)).{8,}$/;
        let passwordDisable = isTrue(complexPasswordCheck) ? !passwordRegex.test(this.state.password) ||
            (this.state.password !== this.state.confirmPassword) : false;

        const createDisabled = (this.state.username.length > 0 && this.state.firstName.length > 0 &&
            !this.state.errorFlag && this.state.password.length > 0 && this.state.confirmPassword.length > 0 &&
            this.state.email.length > 0 && (!this.state.externalOrg || this.state.org !== ''))

        return (
            hasPermissions([aclPermissions.create_user]) ?
                <div style={{backgroundColor: "white", padding: "20px"}} className={"full-parent"}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <div style={{fontSize: 30, fontWeight: 400, marginLeft: 50}}>Create User</div>
                        <div style={{marginLeft: 'auto', marginRight: 50}}>
                            <TrailLinks trails={[
                                {label: 'Home', link: '/'},
                                {label: 'Manage Users', link: '/accesscontrol/'},
                                {label: 'Add Users', link: ''}
                            ]}/>
                        </div>
                    </div>
                    <Divider color={"#000"} style={{opacity: "0.2", margin: 5}}/>
                    <Spin spinning={this.state.isFetching} indicator={antdSpinLoaderIcon}>
                        <Row style={{padding: 20}}>
                            <Col xl={12} xs={24}>
                                <Row>
                                    <Col span={23} offset={1}>
                                        <b>Username</b>
                                        &nbsp;
                                        <span style={{color: "#f00"}}>*</span>
                                    </Col>
                                    <Col span={15} offset={1}>
                                        <Input placeholder="Username" value={this.state.username}
                                               className={"input-field-add-user"}
                                               onChange={this.changeUsername} autoComplete="off"
                                        />
                                    </Col>
                                    <Col span={23} offset={1}>
                                        <div style={{fontSize: 11}}>This will be your unique login id.</div>
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 30}}>
                                    <Col span={7} offset={1}>
                                        <b>First Name</b>
                                        &nbsp;
                                        <span style={{color: "#f00"}}>*</span>
                                    </Col>
                                    <Col span={7} offset={1}>
                                        <b>Last Name</b>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={7} offset={1}>
                                        <Input placeholder="First Name" value={this.state.firstName}
                                               className="input-field-add-user" onChange={this.changeFirstName}
                                               autoComplete="off"/>
                                    </Col>
                                    <Col span={7} offset={1}>
                                        <Input placeholder="Last Name" value={this.state.lastName}
                                               className="input-field-add-user"
                                               onChange={this.changeLastName} autoComplete="off"/>
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 30}}>
                                    <Col span={23} offset={1}>
                                        <b>Email</b>
                                        &nbsp;
                                        <span style={{color: "#f00"}}>*</span>
                                    </Col>
                                    <Col span={15} offset={1}>
                                        <Input placeholder="Email" value={this.state.email}
                                               className={"input-field-add-user"}
                                               onChange={this.changeEmail} autoComplete="off"
                                        />
                                    </Col>
                                    <Col span={23} offset={1}>
                                        <div style={{fontSize: 11}}>
                                            Enter a valid email, For example:{" "}
                                            <span style={{fontStyle: "italic"}}>user@example.com</span>
                                        </div>
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 30}}>
                                    <Col span={7} offset={1}>
                                        <b>Password</b>
                                        &nbsp;
                                        <span style={{color: "#f00"}}>*</span>
                                    </Col>
                                    <Col span={7} offset={1}>
                                        <b>Confirm Password</b>
                                        &nbsp;
                                        <span style={{color: "#f00"}}>*</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={7} offset={1}>
                                        <Password placeholder="Password" value={this.state.password}
                                                  className="input-field-add-user"
                                                  disabled={this.state.autoGeneratePassword}
                                                  onChange={this.changePassword} autoComplete="new-password"/>
                                    </Col>
                                    <Col span={7} offset={1}>
                                        <Password placeholder="Confirm Password" value={this.state.confirmPassword}
                                                  className="input-field-add-user" onChange={this.changeConfirmPassword}
                                                  autoComplete="new-password"
                                                  disabled={this.state.autoGeneratePassword}/>
                                    </Col>
                                </Row>
                                {isTrue((cookie.load("organisation_setting") || {})["complex_password_check"]) &&
                                    <Row style={{marginTop: 30}}>
                                        <Col span={23} offset={1}>
                                            <div className="password-rules" style={{fontStyle: 'italic'}}>
                                                {this.state.password.length > 0 ?
                                                    <PasswordChecklist
                                                        style={{margin: 10}}
                                                        rules={["minLength", "capital", "lowercase", "number", "specialChar", "match"]}
                                                        minLength={8}
                                                        value={this.state.password}
                                                        valueAgain={this.state.confirmPassword}
                                                        onChange={(isValid) => {
                                                        }}
                                                    /> : <>
                                                        <p>Password must:</p>
                                                        <ul>
                                                            <li>Be 8 to 32 characters long</li>
                                                            <li>Contain at least one uppercase letter</li>
                                                            <li>Contain at least one lowercase letter</li>
                                                            <li>Contain at least one digit</li>
                                                            <li>Contain at least one special character</li>
                                                            <li>Match the Confirm Password</li>
                                                        </ul>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>}
                                {this.is_superuser && <Row style={{marginTop: 30}}>
                                    <Col span={6} offset={1}>
                                        <b>External Organisation?</b>
                                    </Col>
                                    <Col span={2}>
                                        <Switch checked={this.state.externalOrg} onChange={this.changeExternalOrg}/>
                                    </Col>
                                </Row>}
                                {this.is_superuser && this.state.externalOrg && <Row style={{marginTop: 30}}>
                                    <Col span={6} offset={1}>
                                        <b>Organisation</b>
                                    </Col>
                                    <Col span={7}>
                                        <Select
                                            showSearch
                                            placeholder="Select Organisation"
                                            className="input-field-add-user"
                                            filterOption={this.filterOption}
                                            value={this.state.org}
                                            style={{width: 200}}
                                            onChange={this.changeOrg}>
                                            {this.props.allOrganisations.map((org) => {
                                                return <Select.Option value={org?.id}>{org?.name}</Select.Option>
                                            })}
                                        </Select>
                                    </Col>
                                </Row>}
                                <Row style={{marginTop: 30}}>
                                    <Col span={23} offset={1}>
                                        <Checkbox checked={this.state.autoGeneratePassword}
                                                  onChange={this.handleAutoGenerateChange}>
                                            <span style={{color: 'rgba(0, 0, 0, 0.65)'}}>Auto-generate Password</span>
                                        </Checkbox>
                                        <div style={{fontSize: 10, marginLeft: 15}}>You will be able to copy and
                                            download this
                                            password after changing it
                                        </div>
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 15}}>
                                    <Col span={23} offset={1}>
                                        <Checkbox checked={this.state.autoChangePassword}
                                                  onChange={(e) => this.setState({autoChangePassword: e.target.checked})}>
                                            <span style={{color: 'rgba(0, 0, 0, 0.65)'}}>
                                                Users must create a new password at next sign-in - Recommended
                                            </span>
                                        </Checkbox>
                                    </Col>
                                </Row>
                                <Row gutter={[0, 24]} style={{marginTop: 10}}>
                                    <Col span={16} offset={1}>
                                        <Button onClick={this.createUser}
                                                disabled={!createDisabled || passwordDisable}
                                                style={(createDisabled && !passwordDisable) ? {
                                                    borderColor: "rgb(112,11,128)", color: "rgb(112,11,128)"
                                                } : {color: "#9a9898"}}
                                        >
                                            Save Changes
                                        </Button>
                                    </Col>
                                    <Col span={17} offset={1}>
                                        {this.state.errorFlag ?
                                            <div className="error-message-general">
                                                {this.state.errorMessage}
                                            </div> : <div>
                                                <span className="error-message-general">*Compulsory Fields</span>
                                            </div>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <DownloadPassword visible={this.state.allowRetrievePassword} onOk={this.handleOk}
                                          onCancel={this.handleCancel} password={this.state.password}
                                          username={this.state.username}/>
                    </Spin>
                </div>
                : <div>
                    {getUnauthorizedComponent()}
                </div>
        )
    }
}

const mapStateToProps = (state) => {

    return {
        allSlides: state.slidesReducer,
        allIds: Object.keys(state.slidesReducer),
        numPages: state.dashboardReducer.numPages,
        urlState: state.searchReducer,
        allUsernames: Object.values(state.usersReducer || {})?.map(({ username }) => username),
        allEmailIds: Object.values(state.usersReducer || {})?.map(({ email }) => email),
        allOrganisations: state.searchUserReducer.organisations,
    }
}

export default connect(mapStateToProps)(AddUserView);
